import { Component, OnInit } from '@angular/core';
import { LessonPlanService } from 'src/app/services/LessonPlan/lesson-plan.service';
import { LookupService } from 'src/app/services/Common/lookup.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-lesson-planning',
  templateUrl: './lesson-planning.component.html',
  styleUrls: ['./lesson-planning.component.css']
})
export class LessonPlanningComponent implements OnInit {

  LessonPlanList = [];
  SubmittedSearch = false;
  Submitted = false;
  UploadMsg = '';
  SelectedFileForUpload: any;
  SubmittedApprove = false;
  ClassList = [];
  SubjectList = [];
  StaffList = [];
  SubjectListSearch = [];
  StaffListSearch = [];

  constructor(private lessonplanservice: LessonPlanService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }

  SearchModel = {
    LPNo: 0,
    LPName: '',
    ChapterName:'',
    ClassID: 0,
    SubjectID: 0,
    StaffID: 0,
  }

  ClearSearch() {
    this.LessonPlanList = [];
    this.SubmittedSearch = false;
    this.SearchModel.ClassID = 0;
    this.SearchModel.LPName = '';
    this.SearchModel.SubjectID = 0;
    this.SearchModel.StaffID = 0;
    this.SearchModel.LPNo = 0;
    this.SearchModel.ChapterName='';
  };



  GetAllLessonPlan() {
    this.spinnerService.show();
    this.lessonplanservice.GetAllLessonPlan(JSON.stringify(this.SearchModel)).subscribe((data: any) => {
      this.LessonPlanList = data.LessonPlanList;
      this.spinnerService.hide();
      this.globalHelper.CheckActionStatus(data);
    });
  };

  SaveUpdateModel = {
    LPID: 0,
    LPNo: 0,
    ClassID: 0,
    LPName: '',
    SubjectID: 0,
    StaffID: 0,
    ChapterName: '',
    Topic: '',
    BookName: '',
    Description: '',
    FilePath: ''
  }

  ClearSave() {
    this.Submitted = false;
    this.SaveUpdateModel.LPID = 0;
    this.SaveUpdateModel.ClassID = 0;
    this.SaveUpdateModel.LPNo = 0;
    this.SaveUpdateModel.SubjectID = 0;
    this.SaveUpdateModel.StaffID = 0;
    this.SaveUpdateModel.LPName = '';
    this.SaveUpdateModel.Description = '';
    this.SaveUpdateModel.ChapterName = '';
    this.SaveUpdateModel.Topic = '';
    this.SaveUpdateModel.BookName = '';
    this.SaveUpdateModel.FilePath = '';
    this.UploadMsg = '';
  };

  Edit(item) {
    this.SaveUpdateModel.LPID = item.LPID;
    this.SaveUpdateModel.Description = item.Description;
    this.SaveUpdateModel.FilePath = item.FilePath;
    this.SaveUpdateModel.LPNo = item.LPNo;
    this.SaveUpdateModel.LPName = item.LPName;
    this.SaveUpdateModel.ClassID = item.ClassID;
    this.GetAllSubject();
  
      this.SaveUpdateModel.SubjectID = item.SubjectID;
      this.GetAllTeacher();
    
   
      this.SaveUpdateModel.StaffID = item.StaffID;
 
    this.SaveUpdateModel.BookName = item.BookName;
    this.SaveUpdateModel.Topic = item.Topic;
    this.SaveUpdateModel.ChapterName = item.ChapterName;
  };

  selectFileforUpload(file) {
    this.SelectedFileForUpload = file[0];
  };

  ValidityState() {
    return this.SaveUpdateModel.ClassID == 0;
  }

  SaveLessonPlan(valid) {
    this.UploadMsg = '';
    this.Submitted = true;
    if (valid && !this.ValidityState()) {
      this.spinnerService.show();
      this.lessonplanservice.SaveLessonPlan(JSON.stringify(this.SaveUpdateModel), this.SelectedFileForUpload).subscribe((data: any) => {
        this.spinnerService.hide();
        if (this.SaveUpdateModel.LPID == 0 && data.webResponse.Status) {
          this.ClearSave();
          this.GetAllLessonPlan();
        }
        else if (data.webResponse.Status) {
          this.GetAllLessonPlan();
        }

      });
    }
  };
  GetLPIDForApprove(item) {
    this.ApprovalModel.LPID = item.LPID;
    this.ApprovalModel.StatusID = 1;
    this.ApprovalModel.ClassID = item.ClassID;
    this.ApprovalModel.SubjectID = item.SubjectID;
    this.ApprovalModel.StaffID = item.StaffID;
  };

  GetLPIDForChange(item) {
    this.ApprovalModel.LPID = item.LPID;
    this.ApprovalModel.StatusID = 3;
    this.ApprovalModel.ClassID = item.ClassID;
    this.ApprovalModel.SubjectID = item.SubjectID;
    this.ApprovalModel.StaffID = item.StaffID;
  };
  GetLPIDForReject(item) {
    this.ApprovalModel.LPID = item.LPID;
    this.ApprovalModel.StatusID = 4;
    this.ApprovalModel.ClassID = item.ClassID;
    this.ApprovalModel.SubjectID = item.SubjectID;
    this.ApprovalModel.StaffID = item.StaffID;
  };

  ApprovalModel = {
    LPID: 0,
    StatusID: 0,
    ClassID: 0,
    SubjectID: 0,
    StaffID: 0,
    Remarks: '',
  }


  ApproveLessonPlan(valid) {
    this.UploadMsg = '';
    this.Submitted = true;
    if (valid) {
      this.spinnerService.show();
      this.lessonplanservice.ApproveLessonPlan(JSON.stringify(this.ApprovalModel)).subscribe((data: any) => {
        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data);
        this.GetAllLessonPlan();
      });
    }
  };

  ClearApprove() {
    this.SubmittedApprove = false;
    this.ApprovalModel.LPID = 0;
    this.ApprovalModel.StatusID = 0;
    this.ApprovalModel.Remarks = '';
  };

  // Init and Lookup

  ngOnInit() {
    this.GetAllClass();
    this.GetAllLessonPlan();
  }

  GetAllClass() {
    this.lookupservice.GetLookupsList('LPClass', '').subscribe((data: any) => {
      this.ClassList = data.LookupItems;
    });
  };
  GetAllSubject() {
    this.SaveUpdateModel.SubjectID = 0;
    this.SaveUpdateModel.StaffID = 0;
    this.spinnerService.show();
    var itemBo = {
      'ItemId': this.SaveUpdateModel.ClassID,

    };
    this.lookupservice.GetLookupsList('LPSubject', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.SubjectList = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetAllTeacher() {
    this.spinnerService.show();
    var itemBo = {
      'ItemId': this.SaveUpdateModel.ClassID,
      'ItemId1': this.SaveUpdateModel.SubjectID,

    };
    this.lookupservice.GetLookupsList('CommClassSubjectTeacher', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.StaffList = data.LookupItems;
      if(this.StaffList!=null && this.StaffList.length==2){
        this.SaveUpdateModel.StaffID=this.StaffList[1].ItemId;
      }
      this.spinnerService.hide();
    });
  };
  GetAllSubjectSearch() {
    this.SearchModel.SubjectID = 0;
    this.SearchModel.StaffID = 0;
    this.spinnerService.show();
    var itemBo = {
      'ItemId': this.SearchModel.ClassID,

    };
    this.lookupservice.GetLookupsList('LPSubject', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.SubjectListSearch = data.LookupItems;
      this.spinnerService.hide();
    });
  };

  GetAllTeacherSearch() {
    this.spinnerService.show();
    var itemBo = {
      'ItemId': this.SearchModel.ClassID,
      'ItemId1': this.SearchModel.SubjectID,

    };
    this.lookupservice.GetLookupsList('CommClassSubjectTeacher', JSON.stringify(itemBo)).subscribe((data: any) => {
      this.StaffListSearch = data.LookupItems;
      if(this.StaffListSearch!=null && this.StaffListSearch.length==2){
        this.SearchModel.StaffID=this.StaffListSearch[1].ItemId;
      }
      this.spinnerService.hide();
    });
  };




}
